import { render, staticRenderFns } from "./PageProvisionslog.vue?vue&type=template&id=48b61b11&scoped=true&"
import script from "./PageProvisionslog.vue?vue&type=script&lang=js&"
export * from "./PageProvisionslog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b61b11",
  null
  
)

export default component.exports